var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 2.0625H2.5C2.25136 2.0625 2.0129 2.16127 1.83709 2.33709C1.66127 2.5129 1.5625 2.75136 1.5625 3V11.125C1.5625 11.3736 1.66127 11.6121 1.83709 11.7879C2.0129 11.9637 2.25136 12.0625 2.5 12.0625H10.625C10.8736 12.0625 11.1121 11.9637 11.2879 11.7879C11.4637 11.6121 11.5625 11.3736 11.5625 11.125V3C11.5625 2.75136 11.4637 2.5129 11.2879 2.33709C11.1121 2.16127 10.8736 2.0625 10.625 2.0625Z",
    stroke: "#606479",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.56299V13.6249C13.75 13.7906 13.6842 13.9496 13.5669 14.0668C13.4497 14.184 13.2908 14.2499 13.125 14.2499H4.06344M4.0625 6.90174L5.9375 8.6283L9.0625 5.41205",
    stroke: "#606479",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllNotification);
export default __webpack_public_path__ + "static/media/AllNotification.3908ce84a6503088b7800497f04ec85c.svg";
export { ForwardRef as ReactComponent };